<!-- Start Introduction -->
<div
  style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-1.webp'); background-position: right; background-size: cover;"
  class="section-agency-benefit section-pt section-pb-60 d-none d-md-block" (window:resize)="onResize($event)">
  <div class="container subbanner">
    <div class="row align-items-center">
      <div class="col-lg-8 col-md-8 col-xl-8">
        <div class="d-none d-sm-block" *ngIf="innerWidth > 768">
          <h1 id="bnr-heading">{{heading}}</h1>
        </div>
      </div>
    </div>
  </div>
</div>

<!-- Banner For Mobile -->

<div style="background: linear-gradient(0deg, rgba(0, 0, 0, 0.0), rgba(0, 0, 0, 0.0)),url('assets/images/header/header-mobile.webp'); background-position: top; background-size: cover;"
    class="section-agency-benefit section-pt section-pb-60 d-block d-md-none">
    <div class="container subbanner">
        <div class="row align-items-center">
            <div class="col-lg-12">
                <div class="mt-50">
                  <!-- header background -->
                </div>
            </div>
        </div>
    </div>
</div>

<!-- Banner Heading For Mobile -->

<div class="container d-block d-md-none" (window:resize)="onResize($event)">
    <div class="row">
        <div class="col-12">
            <div class="mt-15 mb-15 text-center" *ngIf="innerWidth <= 768">
                <h1 id="bnr-heading">{{heading}}</h1>
            </div>
        </div>
    </div>
</div>
<!-- End Introduction -->


<!-- Start Other Features -->
<div class="section-agency-benefit bg-gray section-pt section-pb-60">
  <div class="container">
    <div class="row align-items-center">
      <div class="col-lg-12">
        <h3>Through innovative and best-in class team & product we’ve helped many precious clients of ours to secure
          their mobile business operations and envision disruptive strategies.</h3>
        <h3>Check out how we implement real time Mobile Security and help launch new business models.</h3>
      </div>
    </div>
  </div>
</div>
<!-- End Other Features -->

<!-- Page Conttent -->
<main class="page-content">



  <!-- Start Post Carousel Style-->
  <div class="section-post-carousel section-pt section-pb-60">
    <div class="container">
      <div class="row">
        <div class="col-lg-12">
          <div class="section-title text-center">
            <h2>Protectt.ai</h2>
            <p class="text-center">Your Trusted Partner for Mobile Security</p>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <!-- Start Single Post -->
          <div class="post-carousel mb-30 row">
            <div class="thumb col-md-4">
              <a routerLink="/five-ways-to-enhance-your-android-phone-security">
                <img src="assets/images/blog/five-ways-to-enhance-your-android-phone-security.webp" alt="elementor" class="og_image_url">
              </a>
            </div>
            <div style="padding-top: 0;" class="col-md-8 ptc-content">
              <h4><a routerLink="/five-ways-to-enhance-your-android-phone-security">5 Ways to Enhance your Android Phone
                  Security.</a></h4>
              <ul class="meta d-flex">
                <li><i
                      class="zmdi zmdi-calendar-check"></i> Feb 4, 2021</li>
                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
              </ul>
              <p>Does your heart skip a beat when your phone slips from the pocket? We know how fragile our mobile
                phones can be...</p>
              <div class="post-btn">
                <!-- <a class="readmore-btn btn btn-circle"
                  routerLink="/five-ways-to-enhance-your-android-phone-security">READ MORE</a> -->
                  <a class="readmore-btn btn btn-rectengle"
                  routerLink="/five-ways-to-enhance-your-android-phone-security">READ MORE</a>
              </div>
            </div>
          </div>
          <!-- End Single Post -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <!-- Start Single Post -->
          <div class="post-carousel mb-30 row">
            <div class="thumb col-md-4">
              <a routerLink="/smartphone-antivirus-need-of-the-hour">
                <img src="assets/images/blog/smartphone-antivirus-need-of-the-hour.webp" alt="elementor">
              </a>
            </div>
            <div style="padding-top: 0;" class="col-md-8 ptc-content">
              <h4><a routerLink="/smartphone-antivirus-need-of-the-hour">Smartphone Antivirus: Need of the Hour.</a>
              </h4>
              <ul class="meta d-flex">
                <li><i class="zmdi zmdi-calendar-check"></i> Feb 4, 2021</li>
                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
              </ul>
              <p>Antiviruses have been around for long, it became integral for computers but as most work is getting
                done through cell phones...</p>
              <div class="post-btn">
                <!-- <a class="readmore-btn btn btn-circle" routerLink="/smartphone-antivirus-need-of-the-hour">READ MORE</a> -->
                <a class="readmore-btn btn btn-rectengle" routerLink="/smartphone-antivirus-need-of-the-hour">READ MORE</a>
              </div>
            </div>
          </div>
          <!-- End Single Post -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <!-- Start Single Post -->
          <div class="post-carousel mb-30 row">
            <div class="thumb col-md-4">
              <a routerLink="/seven-must-have-apps-on-your-smartphone">
                <img src="assets/images/blog/seven-must-have-apps-on-your-smartphone.webp" alt="elementor">
              </a>
            </div>
            <div style="padding-top: 0;" class="col-md-8 ptc-content">
              <h4><a routerLink="/seven-must-have-apps-on-your-smartphone">Seven Must Have Apps on Your Smartphone.</a>
              </h4>
              <ul class="meta d-flex">
                <li><i class="zmdi zmdi-calendar-check"></i> Feb 4, 2021</li>
                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
              </ul>
              <p>Travelling, eating, entertainment, banking, shopping, you name it and your phone has got your back....
              </p>
              <div class="post-btn">
                <!-- <a class="readmore-btn btn btn-circle" routerLink="/seven-must-have-apps-on-your-smartphone">READ
                  MORE</a> -->
                  <a class="readmore-btn btn btn-rectengle" routerLink="/seven-must-have-apps-on-your-smartphone">READ
                    MORE</a>
              </div>
            </div>
          </div>
          <!-- End Single Post -->
        </div>
      </div>
      <div class="row">
        <div class="col-lg-12 col-md-12 col-sm-12">
          <!-- Start Single Post -->
          <div class="post-carousel mb-30 row">
            <div class="thumb col-md-4">
              <a routerLink="/enhancing-mobile-app-security-through-rasp">
                <img src="/assets/images/blog/mobile-app-security-rasp.webp" alt="elementor">
              </a>
            </div>
            <div style="padding-top: 0;" class="col-md-8 ptc-content">
              <h4><a routerLink="/enhancing-mobile-app-security-through-rasp">Enhancing Mobile App Security Through
                  RASP.</a></h4>
              <ul class="meta d-flex">
                <li><i class="zmdi zmdi-calendar-check"></i> Feb 4, 2021</li>
                <li><i class="zmdi zmdi-account-calendar"></i> By : Admin</li>
              </ul>
              <p>The influx of digital means has revolutionized the world! All hail to the Digital bonanza. Buying,
                selling, and processing...</p>
              <div class="post-btn">
                <!-- <a class="readmore-btn btn btn-circle" routerLink="/enhancing-mobile-app-security-through-rasp">READ
                  MORE</a> -->
                  <a class="readmore-btn btn btn-rectengle" routerLink="/enhancing-mobile-app-security-through-rasp">READ
                    MORE</a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- End Single Post -->

    </div>
  </div>
  <!-- End Post Carousel  Style-->

</main>
<!--// Page Conttent -->

<!-- Start Floating Buttons -->
<div class="">
  <dl>
    <dt style="top:25%;" class="left">
      <div style="font-size: 25px; position: absolute; right: 10px; color: #fff;" class="fa fa-users">
      </div>
      <div class="online-consultation" style="display:inline-grid;line-height:1; text-align:center;">
        <a href=""><span aria-hidden="true" style="font-size:16px; color: #fff;">Join Our Community</span></a>
      </div>
    </dt>
  </dl>
</div>

<div>
  <dl>
    <dt style="top:30%;" class="right">
      <div style="font-size: 25px; position: absolute; left: 15px; color: #fff;" class="fa fa-comment">
      </div>
      <div class="online-consultation" style="display:inline-grid;line-height:1; text-align:center;">
        <a href=""><span aria-hidden="true" style="font-size:16px; color: #fff;">Feedback</span></a>
      </div>
    </dt>
  </dl>
</div>

<div>
  <dl>
    <dt style="top:35%;" class="left">
      <div style="font-size: 25px; position: absolute; right: 10px; color: #fff;" class="fa fa-newspaper">
      </div>
      <div class="online-consultation" style="display:inline-grid;line-height:1; text-align:center;">
        <a href="#blog-subscribe"><span aria-hidden="true" style="font-size:16px; color: #fff;">Subscribe to our Blog</span></a>
      </div>
    </dt>
  </dl>
</div>

<div>
  <dl>
    <dt style="top:40%;" class="right">
      <div style="font-size: 25px; position: absolute; left: 15px; color: #fff;" class="fa fa-phone">
      </div>
      <div class="online-consultation" style="display:inline-grid;line-height:1; text-align:center;">
        <a routerLink="/about-us"><span aria-hidden="true" style="font-size:16px; color: #fff;">Contact Us</span></a>
      </div>
    </dt>
  </dl>
</div>

<div>
  <dl>
    <dt style="top:45%;" class="left">
      <div style="font-size: 25px; position: absolute; right: 20px; color: #fff;" class="fa fa-info">
      </div>
      <div class="online-consultation" style="display:inline-grid;line-height:1; text-align:center;">
        <a href=""><span aria-hidden="true" style="font-size:16px; color: #fff;">Knowledge Section</span></a>
      </div>
    </dt>
  </dl>
</div>
<!-- End Floating Buttons -->